
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { LoadPaymentConfigState, LoadPaymentConfigStateSuccess, LoadPaymentConfigStateFail, PaymentConfigActionTypes, LoadSubsectionsState, LoadSubsectionsStateSuccess, LoadPaymentOptionStateSuccess, UpdateSubsectionsState, UpdatePaymentOptionState, LoadPaymentProcessorStateSuccess, UpdatePaymentProcessorState, UpdatePaymentConfigState, LoadPaymentProcessorState } from './payment-config.actions';
import { LGEDataService } from '../../../commons';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';
@Injectable()
export class PaymentConfigEffects {

  loadPaymentConfigState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.LoadPaymentConfigState),
      switchMap(() =>
        this.lgeData.GetPaymentConfigs().pipe(
          map(sub => new LoadPaymentConfigStateSuccess(sub)),
          catchError(error => of(new LoadPaymentConfigStateFail(error)))
        )
      )
    )
  )
  UpdatePaymentConfigState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.UpdatePaymentConfigState),
      map((action: UpdatePaymentConfigState) => action.payload),
      switchMap(
        (data) => from(this.lgeData.PaymentConfigIUD(data)).pipe(
          map(pc => new LoadPaymentConfigStateSuccess(pc)),
          catchError(err => of(new LoadPaymentConfigStateFail(err)))
        )
      )
    )
  )
  loadSubsectionsState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.LoadSubsectionsState),
      switchMap(() =>
        from(this.lgeData.GetTaxExemptSubsections()).pipe(
          map(sub => new LoadSubsectionsStateSuccess(sub)),
          catchError(error => of(new LoadPaymentConfigStateFail(error)))
        )
      )
    )
  )

  UpdateSubsectionsState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.UpdateSubsectionsState),
      map((action: UpdateSubsectionsState) => action.payload),
      switchMap((data) =>
        from(this.lgeData.TaxExemptSubsectionsIUD(data))
      ),
      switchMap((sub) => [new LoadPaymentConfigState(), new LoadSubsectionsStateSuccess(sub)]),
      catchError(error => of(new LoadPaymentConfigStateFail(error)))
    )
  )

  loadPaymentOptionState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.LoadPaymentOptionState),
      switchMap(() =>
        from(this.lgeData.GetPaymentOptions())
      ),
      switchMap((payOpt) => [new LoadPaymentProcessorState(), new LoadPaymentOptionStateSuccess(payOpt)]),
      catchError(error => of(new LoadPaymentConfigStateFail(error)))
    )
  )

  UpdatePaymentOptionState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.UpdatePaymentOptionState),
      map((action: UpdatePaymentOptionState) => action.payload),
      switchMap((data) =>
        from(this.lgeData.PaymentOptionIUD(data))
      ),
      switchMap((sub) => [new LoadPaymentProcessorState(), new LoadPaymentOptionStateSuccess(sub)]),
      catchError(error => of(new LoadPaymentConfigStateFail(error)))
    )
  )

  loadPaymentProcessorState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.LoadPaymentProcessorState),
      switchMap(() =>
        from(this.lgeData.GetPaymentProcessor())
      ),
      switchMap((payPrc) => [new LoadPaymentConfigState(), new LoadPaymentProcessorStateSuccess(payPrc)]),
      catchError(error => of(new LoadPaymentConfigStateFail(error)))
    )
  )

  UpdatePaymentProcessorState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentConfigActionTypes.UpdatePaymentProcessorState),
      map((action: UpdatePaymentProcessorState) => action.payload),
      switchMap((data) =>
        from(this.lgeData.PaymentProcessorIUD(data)).pipe(
          map(paySrc => new LoadPaymentProcessorStateSuccess(paySrc)),
          catchError(error => of(new LoadPaymentConfigStateFail(error)))
        )
      ),
    )
  )

  // loadPaymentProcessorStateSucess$: Observable<Action> = this.actions$
  //   .ofType(PaymentConfigActionTypes.LoadPaymentProcessorStateSuccess)
  //   .map(() => new LoadPaymentConfigStateSuccess(null))
  //   // This action happens at startup
  //   .map(() => new LoadPaymentConfigState());

  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) { }
}